import type { AllHTMLAttributes } from 'react'

import cn from 'clsx'

import css from './CloseButton.module.css'

interface CloseButtonProps extends AllHTMLAttributes<HTMLButtonElement> {
    className?: string
    /**
     * @deprecated use aria-label
     */
    ariaLabel?: string
}

export function CloseButton({ className, ariaLabel, ...rest }: CloseButtonProps) {
    return (
        <button
            {...rest}
            className={cn(css.closeBtn, className)}
            aria-label={rest['aria-label'] ?? ariaLabel}
            type="button"
        />
    )
}
